import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { helpCards } from '../mock';

const HelpCards = () => {
  return (
    <section className="py-16 md:py-24 bg-white rounded-t-[48px]">
      <div className="max-w-7xl mx-auto px-5">
        <div className="max-w-2xl mb-10 md:mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1F0068] tracking-tight leading-tight">What help do you need?</h2>
          <p className="mt-4 text-lg text-[#1F0068]/70">Maintenance service plans for the appliances, boilers and home systems you rely on.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {helpCards.map((c) => {
            const Ico = Icons[c.icon];
            return (
              <Link key={c.id} to={c.to}
                className="dhs-card group block bg-[#FFF6EB] rounded-3xl p-7 border border-[#1F0068]/5 hover:bg-white">
                <div className={`w-14 h-14 rounded-2xl ${c.tint} flex items-center justify-center text-[#1F0068] mb-6`}>
                  <Ico className="w-7 h-7" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0068] leading-tight">{c.title}</h3>
                <p className="mt-2 text-sm text-[#1F0068]/70 leading-relaxed">{c.desc}</p>
                <div className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF5C39] group-hover:gap-2.5 transition-all">
                  {c.cta} <ArrowRight className="w-4 h-4" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HelpCards;
